import { render, staticRenderFns } from "./ContactOptions.vue?vue&type=template&id=7012c36f&"
import script from "./ContactOptions.vue?vue&type=script&lang=js&"
export * from "./ContactOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports